import React, { useState, useEffect } from "react";
import AOS from "aos";

import "aos/dist/aos.css";
import "./style.css";

const Procedures = () => {
  const [lang, setLang] = useState("En");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("language") === "En") {
      setLang("En");
    } else if (localStorage.getItem("language") === "Fr") {
      setLang("Fr");
    }
  }, []);

  return (
    <div>
      <div class="bg-img">
        <div class="container">
          <div class="cover-title">
            {lang === "Fr" ? <h1>Procédures</h1> : <h1>Procedures</h1>}
          </div>
        </div>
      </div>
      <div className="container section-procedures">
        {lang === "Fr" ? <h1>Procédures</h1> : <h1>Procedures</h1>}

        {lang === "Fr" ? (
          <div className="procedures-top">
            <p>
              Gold Bar International comprend la complexité des transactions sur
              l’or dans un environnement où trouver de vrais vendeurs et des
              acheteurs compétents semble être plus difficile que jamais.
            </p>
            <p id="procedures-keys">
              D’une manière générale, les principales procédures pour les
              acheteurs qui effectuent une transaction sont les suivantes:
            </p>
          </div>
        ) : (
          <div className="procedures-top">
            <p>
              Gold Bar International understands the complexity of gold
              transactions in an environment where finding true sellers and
              capable buyers appears to be more challenging than ever.
            </p>
            <p id="procedures-keys">
              Broadly speaking, the key procedures for Buyers completing a
              transaction are as follows:
            </p>
          </div>
        )}

        <div className="procedures">
          <div
            className="procedures-card"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure1.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                L’acheteur est présenté à Gold Bar International en remplissant
                un formulaire « Connaissez votre client ».
              </p>
            ) : (
              <p>
                Buyer is introduced to Gold Bar International by completing a
                “Know Your Client” form.
              </p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure4.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                La réunion acheteur-vendeur confirme tous les détails de la
                transaction.
              </p>
            ) : (
              <p>Buyer-Seller meeting confirms all transaction details.</p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-right"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure2.jpg")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                Les paramètres d’achat sont discutés en ce qui concerne les
                spécifications, les prix, les quantités, les calendriers et la
                logistique.
              </p>
            ) : (
              <p>
                Purchase parameters are discussed regarding specifications,
                pricing, quantities, schedules and logistics.
              </p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-left"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure5.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>Le contrat de vente et d’achat est négocié et exécuté.</p>
            ) : (
              <p>Sale and Purchase Agreement is negotiated and executed.</p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-right"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure3.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                L’acheteur soumet le bon de commande avec la preuve de fonds.
              </p>
            ) : (
              <p>Buyer submits Purchase Order along with Proof-of-Funds.</p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-left"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure6.jpg")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                L’or est livré et l’analyse de la raffinerie a lieu chez
                l’acheteur. <br />
                Les fonds de l’acheteur sont libérés, le cas échéant, et la
                propriété de l’or est transférée.
              </p>
            ) : (
              <p>
                Gold is delivered and refinery analysis occurs at Buyer’s
                location.
                <br />
                Buyer funds are released, as appropriate, and gold ownership is
                transferred.
              </p>
            )}
          </div>
        </div>
        <hr />
        {lang === "Fr" ? (
          <p id="procedures-outro" className="p-bottom-text" data-aos="fade-up">
            Bien sûr, chaque transaction peut avoir ses propres variations en
            fonction de la quantité et de l’emplacement des lingots d’or ou des
            lingots et des exigences spécifiques de l’acheteur.
          </p>
        ) : (
          <p id="procedures-outro" className="p-bottom-text" data-aos="fade-up">
            Of course, each transaction may have its own variations depending
            upon the quantity and location of the gold dore bars or bullion and
            any specific requirements of the buyer.
          </p>
        )}
      </div>

      <div className="container section-procedures-mobile">
        {lang === "Fr" ? <h1>Procédures</h1> : <h1>Procedures</h1>}
        <div className="procedures-top">
          {lang === "Fr" ? (
            <div className="procedures-top">
              <p>
                Gold Bar International comprend la complexité des transactions
                sur l’or dans un environnement où trouver de vrais vendeurs et
                des acheteurs compétents semble être plus difficile que jamais.
              </p>
              <p id="procedures-keys">
                D’une manière générale, les principales procédures pour les
                acheteurs qui effectuent une transaction sont les suivantes:
              </p>
            </div>
          ) : (
            <div className="procedures-top">
              <p>
                Gold Bar International understands the complexity of gold
                transactions in an environment where finding true sellers and
                capable buyers appears to be more challenging than ever.
              </p>
              <p id="procedures-keys">
                Broadly speaking, the key procedures for Buyers completing a
                transaction are as follows:
              </p>
            </div>
          )}
        </div>
        <div className="procedures">
          <div
            className="procedures-card"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure1.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                L’acheteur est présenté à Gold Bar International en remplissant
                un formulaire « Connaissez votre client ».
              </p>
            ) : (
              <p>
                Buyer is introduced to Gold Bar International by completing a
                “Know Your Client” form.
              </p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-right"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure2.jpg")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                Les paramètres d’achat sont discutés en ce qui concerne les
                spécifications, les prix, les quantités, les calendriers et la
                logistique.
              </p>
            ) : (
              <p>
                Purchase parameters are discussed regarding specifications,
                pricing, quantities, schedules and logistics.
              </p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-right"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure3.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                L’acheteur soumet le bon de commande avec la preuve de fonds.
              </p>
            ) : (
              <p>Buyer submits Purchase Order along with Proof-of-Funds.</p>
            )}
          </div>
          <div
            className="procedures-card"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure4.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                La réunion acheteur-vendeur confirme tous les détails de la
                transaction.
              </p>
            ) : (
              <p>Buyer-Seller meeting confirms all transaction details.</p>
            )}
          </div>

          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-left"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure5.png")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>Le contrat de vente et d’achat est négocié et exécuté.</p>
            ) : (
              <p>Sale and Purchase Agreement is negotiated and executed.</p>
            )}
          </div>

          <div
            className="procedures-card"
            data-aos-duration="1500"
            data-aos="fade-left"
          >
            <div className="p-card-img">
              <img src={require("../../Assets/procedure6.jpg")} alt="" />
            </div>
            {lang === "Fr" ? (
              <p>
                L’or est livré et l’analyse de la raffinerie a lieu chez
                l’acheteur. <br />
                Les fonds de l’acheteur sont libérés, le cas échéant, et la
                propriété de l’or est transférée.
              </p>
            ) : (
              <p>
                Gold is delivered and refinery analysis occurs at Buyer’s
                location.
                <br />
                Buyer funds are released, as appropriate, and gold ownership is
                transferred.
              </p>
            )}
          </div>
        </div>
        <hr />
        {lang === "Fr" ? (
          <p id="procedures-outro" className="p-bottom-text" data-aos="fade-up">
            Bien sûr, chaque transaction peut avoir ses propres variations en
            fonction de la quantité et de l’emplacement des lingots d’or ou des
            lingots et des exigences spécifiques de l’acheteur.
          </p>
        ) : (
          <p id="procedures-outro" className="p-bottom-text" data-aos="fade-up">
            Of course, each transaction may have its own variations depending
            upon the quantity and location of the gold dore bars or bullion and
            any specific requirements of the buyer.
          </p>
        )}
      </div>
    </div>
  );
};

export default Procedures;
